import React from 'react';

export const UsernameContext = React.createContext({
    user: ""
});
